import React from "react";
import OrganizationDetailsPanel from "../components/organizationDetailsPanel";

function OrganizationDetailsPage() {
  return <OrganizationDetailsPanel />;
}

OrganizationDetailsPage.propTypes = {};
OrganizationDetailsPage.defaultProps = {};

export default OrganizationDetailsPage;
